import { sanitize } from "dompurify";

/**
 * Sanitizes HTML content to prevent XSS attacks
 *
 * Uses DOMPurify with SANITIZE_DOM option which automatically:
 * - Removes dangerous tags (script, iframe, object, etc.)
 * - Removes dangerous attributes (onclick, onerror, etc.)
 * - Keeps safe HTML formatting tags
 *
 * @param html - The HTML string to sanitize
 * @returns Sanitized HTML string safe for rendering
 *
 * @example
 * ```tsx
 * const userInput = '<p>Hello <script>alert("XSS")</script>World</p>';
 * const safeHtml = sanitizeHtml(userInput);
 * // Result: '<p>Hello World</p>'
 * ```
 */
export const sanitizeHtml = (html: string | null | undefined): string => {
  if (!html || typeof html !== "string") {
    return "";
  }

  const htmlWithBreaks = html.replace(/\n/g, "<br>");

  return sanitize(htmlWithBreaks, { SANITIZE_DOM: true });
};
